const Swal = require('sweetalert2')

export const textPopUp = (title, text, icon) => {
    Swal.fire({
        title: title,
        text: text,
        icon: icon,
        confirmButtonColor: '#26264C',
        confirmButtonText: 'Tutup'
    });
}

export const confirmDelete = (title, text, id) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#26264C',
        cancelButtonColor: '#CE1010',
        confirmButtonText: 'Ya, hapus!',
        cancelButtonText: 'Batal'
    }).then((result) => {
        if (result.isConfirmed) {
            return { id: id, confirmed: true };
        } else {
            return { id: id, confirmed: false };
        }
    });
}